import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { DateInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { masterActions, reportingAction } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import ClosedIcon from "../../assets/padlock_flat_style.jpg";
import OpenIcon from "../../assets/5c23f889-065f-43dd-a012-0e87b13e47b8.jpg";
import CustomLoader from "../../components/common/ui/Loader";
import Error from "../error/error";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import { fDate } from "../../utils/formatTime";

const DEFAULT_ACTIVE_STATUS = 1; // Active status default
const DEFAULT_PAGE_NO = 1; // Default page number as a string
const DEFAULT_ROW_COUNT_PER_PAGE = 10; // Default row count per page as a string
const FormSearch = () => {
  const dispatch = useDispatch();
  const {
    logHistoryLastName: logHistoryLastName,
    logHistorFirstName: logHistorFirstName,
  } = useSelector((state) => state.master);
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );

  const reduxManagmentUserName = useSelector(
    (state) => state.reporting?.getRequestFormPermissionManagementUser
  );
  const reduxManagmentUserNamedrpdwn = useSelector(
    (state) => state.reporting?.getRequestFormUsernameDropdown
  );
  const user = useSelector((x) => x.auth.user);
  const reduxRequestVisitorInfoList = useSelector(
    (x) => x?.reporting?.GetLoadReportingInmateRequestVisitorInfoList
  );
  const reduxFormSearchList = useSelector(
    (state) => state.reporting?.LoadRequestFormTypeResponseTimeDetails
  );
  const reduxFormSearchListpopup = useSelector(
    (state) => state.reporting?.LoadRequestFormTypeResponseTimeDetailsPopup
  );
  const reduxThreadPostList = useSelector(
    (state) => state.reporting?.GetReportingInmateRequestForumThreadPostList
  );
  const reduxFormSearchListLoading = useSelector(
    (state) => state.reporting?.TimeDetailsloading
  );
  const reduxTimeDetailsPopuploading = useSelector(
    (state) => state.reporting?.TimeDetailsPopuploading
  );
  const reduxThreadPostListloading = useSelector(
    (state) => state.reporting?.ThreadPostListloading
  );
  const RequestVisitorInfoListLoading = useSelector(
    (state) => state.reporting?.RequestVisitorInfoListLoading
  );
  const shouldShowExcelExport = reduxFormSearchList?.DataList?.length > 0;
  const location = useLocation();
  const { state } = location; // Destructure state from location
  // Retrieve the POD ID from the state, if available
  const selectedRequestFormType = state?.id; // Use optional chaining to prevent errors if state is undefined
  const RequestFormFrom = state?.RequestFormFrom;
  const RequestFormTitle = state?.RequestFormTitle;
  const [initialuserActivityData, setinitialuserActivityData] = useState({
    facilityID: facilityCode,
    requestFormTypeID: selectedRequestFormType,
    requestFormType: RequestFormFrom,
    requestFormID: 0,
    reqCurrentStatus: 2,
    requestCreateStartDate: "",
    requestCreateEndDate: "",
    inmateFirstNames: "",
    inmateLastNames: "",
    InmateFirstNamesId: 0,
    InmateLastNamesId: 0,
    inmateId: "",
    managementUserID: user?.ManagementUserID,
    responseManagementUserID: 0,
    pageNo: DEFAULT_PAGE_NO,
    rowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
    sortBy: "",
  });
  const statusOptions = [
    { value: 2, label: "Both" },
    { value: 1, label: "Request Opened" },
    { value: 0, label: "Request Closed" },
  ];

  const [formAccess, setFacilityPCR] = useState({
    MangementUserID: 0,
    PageNo: 1,
    RowCountPerPage: 5,
  });

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(facilityCode);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("Reporting");
    }
  }, [facilityCode]);

  const [typeOnePopup, settypeOnePopup] = useState({
    RequestVisitorFormID: 0,
    IsManagementUser: 1,
    IsInmate: 0,
    PageNo: 1,
    RowCountPerPage: 10,
  });

  const [typeTwoPopup, settypeTwoPopup] = useState({
    FacilityID: facilityCode,
    RequestFormTypeID: selectedRequestFormType,
    RequestFormType: RequestFormFrom,
    RequestFormID: 0,
    reqCurrentStatus: 2,
    RequestCreateStartDate: "",
    RequestCreateEndDate: "",
    InmateFirstNames: "",
    InmateLastNames: "",
    InmateId: "",
    ManagementUserID: 1,
    ResponseManagementUserID: 0,
    PageNo: DEFAULT_PAGE_NO,
    RowCountPerPage: 10,
    SortBy: "",
  });

  const [typeThreePopup, settypeThreePopup] = useState({
    RequestForumThreadID: 0,
    IsManagementUser: 1,
    IsInmate: 0,
    PageNo: 1,
    RowCountPerPage: 10,
  });

  const handleResetPageandRowCount = () => {
    settypeThreePopup((prevState) => ({
      ...prevState,
      RowCountPerPage: 10,
      PageNo: 1,
    }));
    settypeTwoPopup((prevState) => ({
      ...prevState,
      RowCountPerPage: 10,
      PageNo: 1,
    }));
    settypeOnePopup((prevState) => ({
      ...prevState,
      RowCountPerPage: 10,
      PageNo: 1,
    }));
  };

  const handleRequestFormTitle = (row) => {
    //if (row?.RequestFormCount === 0) return;
    if (row?.RequestFormType === 1) {
      settypeOnePopup((prevState) => ({
        ...prevState,
        RequestVisitorFormID: row.RequestFormID,
        PageNo: 1,
      }));
      // dispatch(reportingAction.GetLoadReportingInmateRequestVisitorInfoList({ RequestVisitorFormID: row.RequestFormID, }));
    } else if (row?.RequestFormType === 60 || row?.RequestFormType === 2) {
      settypeTwoPopup((prevState) => ({
        ...prevState,
        RequestFormID: row.RequestFormID,
        PageNo: 1,
      }));
      //dispatch(reportingAction.LoadRequestFormTypeResponseTimeDetailsPopup({ ...initialuserActivityData, FacilityID: facilityCode, RequestFormID: row.RequestFormID }));
    } else if (
      row?.RequestFormType >= 3 &&
      row?.RequestFormType !== 53 &&
      row?.RequestFormType !== 59 &&
      row?.RequestFormType !== 60
    ) {
      settypeThreePopup((prevState) => ({
        ...prevState,
        RequestForumThreadID: row.RequestFormID,
        PageNo: 1,
      }));
      // dispatch(reportingAction.GetReportingInmateRequestForumThreadPostList({ ...typeThreePopup, RequestForumThreadID: row.RequestFormID }));
    }
  };
  const formTitleNameTypeOneColumn = [
    {
      name: "Posted By",
      selector: (row) => row.UserName,
    },
    {
      name: "Request Status",
      selector: (row) => row.FromStatus,
    },
    {
      width: '180px',
      name: "Created/Replied Date",
      selector: (row) => row.RequestRespondDate,
    },
    {
      name: "Response Time",
      selector: (row) => row.ResponseTime,
    },
  ];

  const formTitleNameTypeTwoColumn = [
    {
      name: "Posted By",
      selector: (row) => row.ManagementUser,
    },
    {
      name: "Request Status",
      selector: (row) => (row.FromStatus === "0" ? "Closed" : row.FromStatus),
    },
    {
      width: '180px',
      name: "Created/Replied Date",
      selector: (row) => row.CreateDateTime,
    },
    {
      name: "Response Time",
      selector: (row) => row.ResponseDateTime,
    },
  ];

  const formTitleNameTypeThreeColumn = [
    {
      name: "Posted By",
      selector: (row) => row.ForumThreadPostBy,
    },
    {
      name: "Response Type",
      selector: (row) =>
        row.IsPostText === 1 && row.IsAttachDocPDF === 1
          ? "Text & Pdf"
          : row.IsPostText === 1
            ? "Text"
            : row.IsAttachDocPDF === 1
              ? "Pdf"
              : "",
    },
    {
      width: '180px',
      name: "Created/Replied Date",
      selector: (row) => row.ReqPostSendDate,
    },
  ];

  const columns = [
    {
      name: "Form Title",
      selector: (row) => row.RequestFormTitle,
      sortable: true,
      key: "RequestFormTitle",
      cell: (row) => (
        <div
          className="Common_Link_Style"
          data-bs-toggle="modal"
          data-bs-target={
            row?.RequestFormType === 1
              ? "#request_form_type1"
              : row?.RequestFormType === 60 || row?.RequestFormType === 2
                ? "#request_form_type2"
                : row?.RequestFormType >= 3 &&
                  row?.RequestFormType !== 53 &&
                  row?.RequestFormType !== 59 &&
                  row?.RequestFormType !== 60
                  ? "#request_form_type3"
                  : ""
          }
          onClick={() => handleRequestFormTitle(row)}
        >
          {row.RequestFormTitle}
        </div>
      ),
    },
    {
      name: "Username",
      selector: (row) => row.ManagementUser,
      key: "ManagementUser",
      sortable: true,
      // cell: (row) =>
      //  row?.TotalRequestCount === 0 ? (
      //   row?.TotalRequestCount
      //  ) : (
      //   <div
      //    className="Common_Link_Style"
      //   //onClick={() => navigateToAddFormsearch(row)}
      //   >
      //    {row.TotalRequestCount}
      //   </div>
      //  ),
    },
    {
      name: "Inmate ID",
      selector: (row) => row.InmateResidentId,
      key: "InmatID",
      sortable: true,
    },
    {
      name: "Inmate Full Name",
      selector: (row) => row.InmateName,
      key: "InmateFullName",
      sortable: true,
    },
    {
      name: "Created Date Time",
      selector: (row) => row.CreateDateTime,
      key: "CreatedDate",
      sortable: true,
      //center: true,
    },
    {
      name: "Response Time",
      selector: (row) => row.ResponseDateTime,
      key: "ResponseDate",
      sortable: true,
      center: true,
    },
    {
      name: "Last Reply Date Time",
      selector: (row) => row.LastReplayDate,
      key: "LastReplayDate",
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.FromStatus,
      key: "FromStatus",
      cell: (row) =>
        row.FromStatus === "0" ? (
          <span className="status-Closed">Closed</span>
        ) : (
          <span className="status-open">Open</span>
        ),
      // cell: (row) => (
      //   <div>
      //     <img
      //       className="in-icon-size"
      //       src={row.FromStatus === "0" ? ClosedIcon : OpenIcon}
      //       alt={row.FromStatus === "0" ? "Closed" : "Open"}
      //       title={row.FromStatus === "0" ? "Closed" : "Open"}
      //     />
      //   </div>
      // ),
    },
  ];

  useEffect(() => {
    const loadFacilities = async () => {
      try {
        await dispatch(
          masterActions.LoadFacilityDropDown({
            FacilityID: 0,
            ActiveStatus: DEFAULT_ACTIVE_STATUS,
          })
        );
      } catch (error) {
        console.error("Error loading facilities:", error);
      }
    };
    loadFacilities();
  }, []);

  useEffect(() => {
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimeDetails({
        ...initialuserActivityData,
        // RequestFormTypeID: 1,
        // RequestFormType: 1,
        facilityID: facilityCode,
      })
    );
  }, [
    initialuserActivityData?.rowCountPerPage,
    initialuserActivityData?.pageNo,
    facilityCode,
  ]);

  useEffect(() => {
    if (typeThreePopup.RequestForumThreadID === 0) return;
    dispatch(
      reportingAction.GetReportingInmateRequestForumThreadPostList({
        ...typeThreePopup,
        RequestForumThreadID: typeThreePopup.RequestForumThreadID,
      })
    );
  }, [
    typeThreePopup?.RowCountPerPage,
    typeThreePopup?.PageNo,
    typeThreePopup?.RequestForumThreadID,
  ]);

  useEffect(() => {
    if (typeOnePopup.RequestVisitorFormID === 0) return;
    dispatch(
      reportingAction.GetLoadReportingInmateRequestVisitorInfoList({
        ...typeOnePopup,
        RequestVisitorFormID: typeOnePopup.RequestVisitorFormID,
      })
    );
  }, [
    typeOnePopup?.RowCountPerPage,
    typeOnePopup?.PageNo,
    typeOnePopup?.RequestVisitorFormID,
  ]);

  useEffect(() => {
    if (typeTwoPopup.RequestFormID === 0) return;
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimeDetailsPopup({
        ...typeTwoPopup,
        RequestFormID: typeTwoPopup.RequestFormID,
      })
    );
  }, [
    typeTwoPopup?.RowCountPerPage,
    typeTwoPopup?.PageNo,
    typeTwoPopup?.RequestFormID,
  ]);

  //dispatch(reportingAction.LoadRequestFormTypeResponseTimeDetailsPopup({ ...initialuserActivityData, FacilityID: facilityCode, RequestFormID: row.RequestFormID }))

  useEffect(() => {
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: "",
      })
    );
    dispatch(
      masterActions.GetInmateLastName({
        facilityID: facilityCode,
        FirstName: "",
      })
    );
    // dispatch(
    //   reportingAction.GetRequestFormPermissionManagementUser(facilityCode)
    // );
    dispatch(
      reportingAction.GetRequestFormSearchUsernameDropdown(facilityCode)
    );
  }, [facilityCode]);

  const paramsCopy = { ...initialuserActivityData };
  const handleDocDateChange = (value, name) => {
    const date = fDate(value);
    paramsCopy[name] = date || "";
    setinitialuserActivityData(paramsCopy);
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && paramsCopy[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDocDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  // Function to handle dropdown changes for different fields
  const updateSelectedOption = (selectedOption, name) => {
    // Create a shallow copy of the initial log history data
    const paramsCopy = { ...initialuserActivityData };

    // Helper function to update state and params
    const updatePODData = (value) => {
      const updatedValue = value != null ? value : ""; // Allow empty values
      setinitialuserActivityData((prev) => {
        const updatedData = { ...prev };

        // if (name === "RequestCreateStartDate") {
        //   updatedData.RequestCreateStartDate_Show = updatedValue;
        // } else if (name === "RequestCreateEndDate") {
        //   updatedData.RequestCreateEndDate_Show = updatedValue;
        // }

        updatedData[name] = updatedValue;
        paramsCopy[name] = updatedValue;

        return updatedData;
      });
    };

    // Handle specific cases based on field name
    switch (name) {
      case "responseManagementUserID":
        updatePODData(parseInt(selectedOption?.value || 0, 10));
        break;

      case "requestFormTypeID":
        updatePODData(parseInt(selectedOption?.value || 0, 10));
        break;
      case "reqCurrentStatus":
        updatePODData(selectedOption ? parseInt(selectedOption.value, 10) : 2);
        break;
      // case "RequestCreateStartDate":
      // case "RequestCreateEndDate": {
      //   const formattedDate = selectedOption
      //     ? selectedOption.toISOString().split("T")[0]
      //     : "";
      //   updatePODData(formattedDate);
      //   break;
      // }
      default:
        updatePODData(selectedOption?.label || "");
        break;
    }

    // Add FacilityID and PodID to the params copy
    const updateFacilityID = {
      ...paramsCopy,

      FacilityID: facilityCode,
    };

    // // Dispatch the action for log history if not dealing with FromDate or ToDate
    // if (!["RequestCreateStartDate", "RequestCreateEndDate"].includes(name)) {
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimeDetails(updateFacilityID)
    );
    // }
  };

  const resetUserActivity = () => {
    // Default values for reset
    const DEFAULT_RESET_STATE = {
      facilityID: facilityCode,
      requestFormTypeID: selectedRequestFormType,
      requestFormType: RequestFormFrom,
      requestFormID: 0,
      reqCurrentStatus: 2,
      requestCreateStartDate: "",
      requestCreateEndDate: "",
      inmateFirstNames: "",
      inmateLastNames: "",
      InmateFirstNamesId: 0,
      InmateLastNamesId: 0,
      inmateId: "",
      managementUserID: user?.ManagementUserID,
      responseManagementUserID: 0,
      pageNo: DEFAULT_PAGE_NO,
      rowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      sortBy: "",
    };
    setinitialuserActivityData(DEFAULT_RESET_STATE);
    // Early return if facilityCode is not available
    if (!facilityCode) return;
    // Dispatch actions to reset names and load log history
    dispatch(
      masterActions.GetInmateLastName({
        facilityID: facilityCode,
        FirstName: "",
      })
    );
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: "",
      })
    );
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimeDetails(
        DEFAULT_RESET_STATE
      )
    );
  };

  const updateLastandFirstName = (selectedOption, name) => {
    const updatedSearch = { ...initialuserActivityData };

    const loadList = () => {
      updatedSearch.pageNo = 1;
      updatedSearch.rowCountPerPage = 10;
      updatedSearch.facilityID = facilityCode;

      dispatch(
        reportingAction.LoadRequestFormTypeResponseTimeDetails(updatedSearch)
      );
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.InmateFirstNamesId = selectedOption?.value || 0;
      dispatch(
        masterActions.GetInmateLastName({
          facilityID: facilityCode,
          FirstName: "",
        })
      );
      loadList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.InmateLastNamesId = selectedOption?.value || 0;

      updatedSearch.inmateFirstNames = "";
      updatedSearch.InmateFirstNamesId = 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: facilityCode,
          LastName: updatedSearch?.inmateLastNames,
        })
      );

      loadList();
    };

    switch (name) {
      case "inmateLastNames":
        handleLastName();
        break;

      case "inmateFirstNames":
        handleFirstName();
        break;

      default:
        break;
    }
    setinitialuserActivityData(updatedSearch);
  };

  const generateExcelReport = () => {
    // Define the title of the Excel sheet
    const title = "RequestFormReport";

    // Define the column headers for Excel
    const generateExcelColumns = [
      "Form Title",
      "Username",
      "Inmate ID",
      "Inmate Full Name",
      "Created Date Time",
      "Response Time",
      "Last Reply Date Time",
      "Status",
    ];

    const updateTotalRows = {
      ...initialuserActivityData,
      rowCountPerPage: reduxFormSearchList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
      //FacilityID: facilityCode,
    };

    // Dispatch and process the response
    dispatch(
      reportingAction?.LoadRequestFormTypeResponseTimeDetails(updateTotalRows)
    )
      .then((response) => {
        // Ensure logHistoryFullData and DataList are valid
        const { DataList = [] } = response.payload || {}; // Assuming response contains DataList directly
        // Map the data for Excel
        const docList = DataList.map((obj) => ({
          RequestFormTitle: obj.RequestFormTitle,
          ManagementUser: obj.ManagementUser,
          InmateResidentId: obj.InmateResidentId,
          InmateName: obj.InmateName,
          CreateDateTime: obj.CreateDateTime,
          ResponseDateTime: obj.ResponseDateTime,
          LastReplayDate: obj.LastReplayDate,
          Status: obj.FromStatus === "0" ? "Closed" : "Open",
        }));

        // Check if there is data before generating the Excel
        //if (docList.length === 0) return
        generateXlsx(docList, generateExcelColumns, title);
      })
      .catch((error) => {
        // Handle errors gracefully
        console.error("Error loading Inmate Login Log History:", error);
      });
  };

  //The function effectively updates the state based on input changes.
  const updateFormField = (e) => {
    // Ensure e.target is defined to prevent destructuring errors
    const { target } = e || {};

    if (!target) return; // Exit if target is not available

    const { name, value } = target;

    // Update state using setinitialuserActivityData with previous state
    setinitialuserActivityData((prev) => ({
      ...prev,
      [name]: value, // Set the value dynamically based on input name
    }));
  };

  const handleManagmentUserSearchSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const updateFacilityID = {
      ...initialuserActivityData,
      pageNo: 1,
      rowCountPerPage: 10,
      facilityID: facilityCode,
    };
    setinitialuserActivityData(updateFacilityID);

    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimeDetails(updateFacilityID)
    ); // Dispatch the action to load POD list
  };

  const handleRowPerPage = (page) => {
    setinitialuserActivityData((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
    }));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    setinitialuserActivityData((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...initialuserActivityData };
    const newSortOrder = search.sortBy?.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    // dispatch(reportingAction?.setreqActivityDataSearch(search));
    setinitialuserActivityData(search);
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimeDetails({
        ...initialuserActivityData,
        facilityID: facilityCode,
        sortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handlePCRRowPerPage = (page) => {
    setinitialuserActivityData((prevState) => ({
      ...prevState,
      RowCountPerPage: page,
    }));
  };

  const handlePCRPageChange = (page) => {
    setinitialuserActivityData((prevState) => ({
      ...prevState,
      PageNo: page,
    }));
  };

  const handleTypeOneRowPerPage = (page) => {
    settypeOnePopup((prevState) => ({
      ...prevState,
      RowCountPerPage: page,
    }));
  };

  const handleTypeOnePageChange = (page) => {
    settypeOnePopup((prevState) => ({
      ...prevState,
      PageNo: page,
    }));
  };
  const handleTypeTwoRowPerPage = (page) => {
    settypeTwoPopup((prevState) => ({
      ...prevState,
      RowCountPerPage: page,
    }));
  };

  const handleTypeTwoPageChange = (page) => {
    settypeTwoPopup((prevState) => ({
      ...prevState,
      PageNo: page,
    }));
  };

  const handleTypeThreeRowPerPage = (page) => {
    settypeThreePopup((prevState) => ({
      ...prevState,
      RowCountPerPage: page,
    }));
  };

  const handleTypeThreePageChange = (page) => {
    settypeThreePopup((prevState) => ({
      ...prevState,
      PageNo: page,
    }));
  };

  // if (loading) {
  //   return <CustomLoader />;
  // }

  if (reduxFormSearchListLoading) {
    return <CustomLoader />;
  }
  return (
    <div>
      {!selectedRequestFormType ? (
        <Error />
      ) : (
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all   p-4 border border-dark-grey mt-3 w-100">
            <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap mt-2">
              <h2 className="mb-4 form_title_uppercase text-color">
                {facilityCode !== 0 ? "  Form search" : ""}
              </h2>
              <div className="d-flex flex-wrap gap-3 align-items-center">
                <Button
                  label="Back"
                  type="button"
                  status="primary"
                  icon={"fa-solid fa-angle-left"}
                  onClick={() => {
                    history.navigate("Reporting");
                  }}
                />
              </div>
            </div>
            <>
              <form onSubmit={handleManagmentUserSearchSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="InmateId"
                        id="InmateId"
                        label="Type"
                        value={RequestFormTitle}
                        disabled
                      ></TextInput>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <TextInput
                        name="inmateId"
                        id="inmateId"
                        label="Inmate ID"
                        value={initialuserActivityData.inmateId}
                        handleChange={updateFormField}
                        placeholder="Inmate ID"
                        required={false}
                        maxLength={20}
                      ></TextInput>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <SelectInput
                        options={logHistoryLastName}
                        value={initialuserActivityData.InmateLastNamesId}
                        handleChange={(selectedOption) =>
                          updateLastandFirstName(
                            selectedOption,
                            "inmateLastNames"
                          )
                        }
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={
                          initialuserActivityData?.InmateLastNamesId !== 0
                        }
                        //placeholder="--ALL--"
                        label="Inmate Last Name"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <SelectInput
                        options={logHistorFirstName}
                        value={initialuserActivityData.InmateFirstNamesId}
                        handleChange={(selectedOption) =>
                          updateLastandFirstName(
                            selectedOption,
                            "inmateFirstNames"
                          )
                        }
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={
                          initialuserActivityData?.InmateFirstNamesId !== 0
                        }
                        placeholder="--ALL--"
                        label="Inmate First Name"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <SelectInput
                        //options={reduxManagmentUserName}
                        options={reduxManagmentUserNamedrpdwn}
                        value={initialuserActivityData.responseManagementUserID}
                        handleChange={(selectedOption) =>
                          updateSelectedOption(
                            selectedOption,
                            "responseManagementUserID"
                          )
                        }
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={
                          initialuserActivityData?.responseManagementUserID !==
                          0
                        }
                        //placeholder="--ALL--"
                        label="Username"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <DateInput
                        value={initialuserActivityData.requestCreateStartDate} // Ensure proper date object
                        handleChange={(e) =>
                          handleDocDateChange(e, "requestCreateStartDate")
                        }
                        name="FromDate"
                        label={"Created Start Date"}
                        minDate={new Date(2017, 0, 1)}
                        maxDate={
                          initialuserActivityData.requestCreateEndDate
                            ? initialuserActivityData.requestCreateEndDate
                            : new Date()
                        }
                        required={false}
                        isClearable={
                          initialuserActivityData?.requestCreateStartDate
                        }
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        handleKeyDown={(e) =>
                          handleDateEnterKey(e, "RequestCreateStartDate")
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      <DateInput
                        value={initialuserActivityData.requestCreateEndDate} // Ensure proper date object
                        // handleChange={(selectedOption) => {
                        //   updateSelectedOption(
                        //     selectedOption,
                        //     "RequestCreateEndDate"
                        //   );
                        handleChange={(e) =>
                          handleDocDateChange(e, "requestCreateEndDate")
                        }
                        name="ToDate"
                        minDate={
                          initialuserActivityData?.requestCreateStartDate
                            ? new Date(
                              Math.max(
                                new Date(2017, 0, 1),
                                new Date(
                                  initialuserActivityData?.requestCreateStartDate
                                )
                              )
                            )
                            : new Date(2017, 0, 1)
                        }
                        maxDate={new Date()}
                        label={"Created End Date"}
                        isClearable={
                          initialuserActivityData?.requestCreateEndDate
                            ? true
                            : false
                        }
                        required={false}
                        disabled={false}
                        yearDropDown={true}
                        monthDropDown={true}
                        handleKeyDown={(e) =>
                          handleDateEnterKey(e, "requestCreateEndDate")
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating mb-3">
                      {/* Status */}
                      <SelectInput
                        options={statusOptions}
                        value={initialuserActivityData.reqCurrentStatus}
                        handleChange={(selectedOption) =>
                          updateSelectedOption(
                            selectedOption,
                            "reqCurrentStatus"
                          )
                        }
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={false}
                        isLoading={false}
                        isClearable={
                          initialuserActivityData?.reqCurrentStatus !== 2
                        }
                        placeholder="--ALL--"
                        label="Form Status"
                      />
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
                  <Button
                    variant="primary"
                    className="me-2"
                    label={"SEARCH"}
                    type={"submit"}
                    status={"primary"}
                    disabled={false}
                    icon={"search"}
                  ></Button>
                  <Button
                    variant="secondary"
                    className="me-2"
                    onClick={resetUserActivity}
                    label={"RESET"}
                    type={"button"}
                    status={"secondary"}
                    icon={"fa-solid fa-rotate-right"}
                    disabled={false}
                  />
                </div>
              </form>
            </>
          </div>
          <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
            <div className="d-flex flex-wrap justify-content-between mb-2 align-items-center">
              <div>
                <h2 className="form_title_uppercase mb-4 text-color">
                  Form search List
                </h2>
              </div>

              <div className="d-flex flex-wrap gap-3 align-items-center">
                {shouldShowExcelExport && (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={generateExcelReport}
                  />
                )}
              </div>
            </div>
            <div>
              {/* Form Title – Grid click (Form Type Selected value =1) */}
              <CommonModal
                modalId="request_form_type1"
                title="Request Form Details"
                handleCloseIcon={handleResetPageandRowCount}
                loader={RequestVisitorInfoListLoading}
                bodyContent={
                  <>
                    <h4>Form Title : {RequestFormTitle}</h4>
                    <Table
                      key={typeOnePopup?.RowCountPerPage}
                      columns={formTitleNameTypeOneColumn}
                      data={reduxRequestVisitorInfoList?.DataList}
                      pagination
                      onChangeRowsPerPage={handleTypeOneRowPerPage}
                      onChangePage={handleTypeOnePageChange}
                      totalRowCount={
                        reduxRequestVisitorInfoList?.TotalRecordCount
                      }
                      currentPage={typeOnePopup?.PageNo}
                      paginationPerPage={typeOnePopup.RowCountPerPage}
                    />
                  </>
                }
                footerContent={
                  <button
                    className="btn button-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      handleResetPageandRowCount();
                    }}
                  >
                    Close
                  </button>
                }
              />
            </div>
            <div>
              {/* Form Title – Grid click (Form Type Selected value =60 || 2) */}
              <CommonModal
                modalId="request_form_type2"
                title="Request Form Details"
                handleCloseIcon={handleResetPageandRowCount}
                loader={reduxTimeDetailsPopuploading}
                bodyContent={
                  <>
                    <h4>Form Title : {RequestFormTitle}</h4>
                    <Table
                      key={typeTwoPopup?.RowCountPerPage}
                      columns={formTitleNameTypeTwoColumn}
                      data={reduxFormSearchListpopup?.DataList}
                      pagination
                      onChangeRowsPerPage={handleTypeTwoRowPerPage}
                      onChangePage={handleTypeTwoPageChange}
                      totalRowCount={reduxFormSearchListpopup?.TotalRecordCount}
                      currentPage={typeTwoPopup?.PageNo}
                      paginationPerPage={typeTwoPopup.RowCountPerPage}
                    />
                  </>
                }
                footerContent={
                  <button
                    className="btn button-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      handleResetPageandRowCount();
                    }}
                  >
                    Close
                  </button>
                }
              />
            </div>

            <div>
              {/* Form Title – Grid click (Form Type Selected value > 3 &&  !=53  && != 59 && !=60) */}
              <CommonModal
                modalId="request_form_type3"
                title="Request Form Details"
                handleCloseIcon={handleResetPageandRowCount}
                loader={reduxThreadPostListloading}
                bodyContent={
                  <>
                    <h4>Form Title : {RequestFormTitle}</h4>
                    <Table
                      key={typeThreePopup?.RowCountPerPage}
                      columns={formTitleNameTypeThreeColumn}
                      data={reduxThreadPostList?.DataList}
                      pagination
                      onChangeRowsPerPage={handleTypeThreeRowPerPage}
                      onChangePage={handleTypeThreePageChange}
                      totalRowCount={reduxThreadPostList?.TotalRecordCount}
                      currentPage={typeThreePopup?.PageNo}
                      paginationPerPage={typeThreePopup?.RowCountPerPage}
                    />
                  </>
                }
                footerContent={
                  <button
                    className="btn button-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      handleResetPageandRowCount();
                    }}
                  >
                    Close
                  </button>
                }
              />
            </div>

            <Table
              columns={columns}
              data={reduxFormSearchList?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={reduxFormSearchList?.TotalRecordCount}
              currentPage={initialuserActivityData?.pageNo}
              paginationPerPage={initialuserActivityData.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={initialuserActivityData?.sortBy?.split(" ")[0]}
              sortDirection={initialuserActivityData?.sortBy?.split(" ")[1]}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(FormSearch);
